export default __webpack_public_path__ + "static/media/fashion-premium-license.a83cfcc2.jpg";